import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-cinch-card',
  template: '',
  styleUrl: './base-cinch-card.component.scss'
})
export class BaseCinchCardComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
}
